import { useState } from "react";

export default function ImageWithFallback(props) {
    const [didError, setDidError] = useState(false);
    const { src, alt, style, className, ...rest } = props;

    if (didError) {
        return (
            <div
                className={className || ""}
                style={{
                    ...style,
                    display: "inline-block",
                    backgroundColor: "#f3f3f3",
                    textAlign: "center",
                }}
            >
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%", height: "100%" }}>
                    <img
                        src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODgiIGhlaWdodD0iODgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBvcGFjaXR5PSIuMyIgZmlsbD0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIzLjciPjxyZWN0IHg9IjE2IiB5PSIxNiIgd2lkdGg9IjU2IiBoZWlnaHQ9IjU2IiByeD0iNiIvPjxwYXRoIGQ9Im0xNiA1OCAxNi0xOCAzMiAzMiIvPjxjaXJjbGUgY3g9IjUzIiBjeT0iMzUiIHI9IjciLz48L3N2Zz4KCg=="
                        alt="Platzhalter"
                        {...rest}
                        data-original-url={src}
                    />
                </div>
            </div>
        );
    }

    return (
        <img
            src={src}
            alt={alt}
            style={style}
            className={className}
            {...rest}
            onError={() => setDidError(true)}
        />
    );
}
